import './index.pcss'
import $ from 'jquery';

$('.map').on('click', '.map__link li', function () {
    setTimeout(function(){
        getLatLong()
        onApiLoaded();
    }, 500);
});
